<!--<nz-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [nzDisabled]="disabled" [nzMode]="mode"-->
<!--           [nzPlaceHolder]="'component.select.placeholder' | transloco"-->
<!--           [nzDropdownStyle]="{'max-height': '300px', 'overflow': 'auto'}"-->
<!--           nzAllowClear [nzDropdownMatchSelectWidth]="false"-->
<!--           nzShowSearch>-->
<!--  @for (op of options; track op.code) {-->
<!--    <nz-option [nzValue]="op.code" nzCustomContent [nzLabel]="op.title | uiLabel">-->
<!--      <i nz-icon [nzType]="op.enabled ? 'eye' : 'eye-invisible'" nzTheme="outline"></i> {{ op.title | uiLabel }}-->
<!--      <span *ngIf="codeVisible">[{{op.code}}]</span>-->
<!--    </nz-option>-->
<!--  }-->
<!--</nz-select>-->



<nz-tree-select #treeSelect
                style="width: 250px"
                [nzPlaceHolder]="'component.select.placeholder' | transloco"
                [(ngModel)]="selected"
                (ngModelChange)="onModelChanged($event)"
                [nzMaxTagCount]="3"
                [nzMaxTagPlaceholder]="omittedPlaceHolder"
                [nzNodes]="options"
                [nzTreeTemplate]="option"
                [nzDefaultExpandAll]="false"
                [nzCheckable]="mode === 'multiple'"
                [nzAllowClear]="nzAllowClear()"
                [nzDropdownStyle]="{'max-height': '300px', 'overflow': 'auto'}"
                [nzMultiple]="mode === 'multiple'"
></nz-tree-select>
<ng-template #omittedPlaceHolder let-omittedValues> + {{ omittedValues.length }}</ng-template>
<ng-template #option let-node>
  @if (!node.origin.enabled) {
    <i nz-icon nzType="eye-invisible" nzTheme="outline"></i>
  }
  {{ node.title }}
</ng-template>
